import { makeStyles } from '@material-ui/styles'

export default makeStyles(_ => ({
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'end',
  },
  buttonPlanCreate: {
    alignSelf: 'end',
  },
  buttonFilterName: {
    marginTop: 5,
    marginBottom: 5,
  },
}))
